export default __webpack_public_path__ + "static/media/Qhackslogoblack_witharrow.8a977417.png";